import Vue from "vue";
import Vuex from "vuex";

import auth from "@store/modules/auth";
import user from "@store/modules/user";
import common from "@store/modules/common";
import membership from "@modules/membership/_store/";
import invoice from "@modules/invoice/_store/";
import order from "@modules/order/_store/";
import payment from "@modules/payment/_store/";
import team from "@modules/team/_store/";
import stats from "@modules/stats/_store/";
import teamnomination from "@modules/teamnomination/_store/";
import product from "@modules/product/_store/";
import booking from "@modules/booking/_store/";
import draw from "@modules/draw/_store/";
import referee from "@modules/referee/_store/";
import roster from "@modules/roster/_store/";
import coupon from "@modules/coupon/_store/";
import donation from "@modules/donation/_store/";
import plans from "@modules/plans/_store/";
import classes from "@modules/classes/_store/";
import hpcenroll from "@modules/hpcenroll/_store/";
import hpcsubscription from "@modules/hpcsubscription/_store/";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
    modules: {
        auth,
        user,
        common,
        membership,
        invoice,
        order,
        payment,
        team,
        stats,
        teamnomination,
        product,
        booking,
        draw,
        referee,
        roster,
        coupon,
        donation,
        plans,
        classes,
        hpcenroll,
        hpcsubscription,
    },
    strict: debug,
});
